var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-time"},[_vm._v(" На Камчатке "),_c('span',{staticClass:"site-time__time"},[_vm._v(_vm._s(_vm.currentTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }